import PropTypes from 'prop-types';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { add, load } from '../../../reducers/laborClasses/laborClasses.actions';
import { laborClasses, loading } from '../../../reducers/laborClasses/laborClasses.reducer';
import { Spinner } from '../../Spinner/Spinner';
import './AdminLaborClasses.css';
import ConnectedLaborClassForm from './LaborClassForm/LaborClassForm';

export class AdminLaborClasses extends React.Component {
  componentDidMount() {
    this.props.load();
  }

  render() {
    return (
      <span>
        <Spinner isLoading={this.props.areLaborClassesLoading} />
        <Row  style={{ 'margin-bottom': '15px' }}><Col><Button onClick={this.props.addLaborClass} bsStyle="primary">Add New Labor Class</Button></Col></Row>
        {this.props.laborClasses.map(laborClass => (
          <Row key={laborClass.id}>
            <Col>
              <ConnectedLaborClassForm laborClass={laborClass} />
            </Col>
          </Row>
          ))}
        <Row><Col><Button onClick={this.props.addLaborClass} bsStyle="primary">Add New Labor Class</Button></Col></Row>
      </span>
    );
  }
}

AdminLaborClasses.propTypes = {
  load: PropTypes.func.isRequired,
  addLaborClass: PropTypes.func.isRequired,
  areLaborClassesLoading: PropTypes.bool.isRequired,
  laborClasses: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export const mapStateToProps = state => ({
  areLaborClassesLoading: loading(state),
  laborClasses: laborClasses(state),
});

export const mapDispatchToProps = dispatch => ({
  load: () => dispatch(load()),
  addLaborClass: () => dispatch(add()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminLaborClasses);



// WEBPACK FOOTER //
// ./src/components/Admin/LaborClasses/AdminLaborClasses.jsx